import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as messageInfo from '../message-info'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: messageInfo.RESOURCE.payload.dimension.partialId,
      partialId: messageInfo.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Snapshot,
    }),
    description:
      'Position of this entry within its message, which is the order entries are read back in',
    isOptional: false,
    name: 'Sequence',
    partialId: PartialId.Standard.create('seq'),
    type: core.common.value.types.Intrinsic.Integer,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
